export const ActivateAccountType = {
  PAYMENT: 1,
  ELECTION: 2,
};
